import { SizeBasedOnChildren as n } from "@project-rouge/rg-core";
import { Box3 as a, Matrix4 as i, Vector3 as s } from "three";
const c = (r, t = !1) => {
  if (t)
    for (const e of r.rgChildren)
      c(e, t);
  if (!n.includes(r.userData.type))
    return r;
  const o = new a().setFromObject(r);
  return o.applyMatrix4(new i().makeRotationFromQuaternion(r.quaternion.clone().invert())), r.userData.size = o.getSize(new s()).toArray(), r.userData.anchor = o.min.clone().divide(o.min.clone().sub(o.max)).toArray(), r.updateGeo(), r;
};
export {
  c as RgResize
};
//# sourceMappingURL=index.js.map
